module.exports = __webpack_public_path__ + "static/media/Fichier 27.4a00a8fd.svg";